<template>
    <v-layout row wrap>
        <v-tabs dark centered>

            <v-tabs-bar class="grey darken-3">                      
                <v-tabs-slider color="orange"></v-tabs-slider>
                <v-tabs-item href="#tab1" >
                    <v-btn flat class="grey--text">
                        Warengruppen
                    </v-btn>
                </v-tabs-item>
                 
                <v-tabs-slider class="orange"></v-tabs-slider>
            </v-tabs-bar> 


            <v-tabs-items>
                <v-tabs-content id="tab1">
                    <div>
                        <keep-alive>
                            <form-one v-on:submitted="submitForm"></form-one>
                        </keep-alive>
                    </div>
                </v-tabs-content>

                

            </v-tabs-items>
        </v-tabs> 
    </v-layout>
</template>

<script>

import formOne from './importWarengruppen.vue';


export default {
    components: {
        'form-one': formOne,
        
    },
    data() {
        return {
            
            
        }
    }, 
    computed: {
        
        
    },
    mounted(){
               
        
        
           
    },
    methods: {
        submitForm: function(data) {
            this.$store.commit('setMessagebar', false)
            this.$store.dispatch('postCSV', data).then((response)=>{                                
                
            })
            this.$store.commit('setMessagebar', true)
        },
    }
    
}
</script>

<style>
    
    
</style>



// WEBPACK FOOTER //
// import.vue?47b50cfe